import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { ContainerType } from '../../core/models/container-type.model';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-container-type-detail',
  templateUrl: './container-type-detail.component.html',
  styleUrls: ['./container-type-detail.component.scss'],
  standalone: true,
  imports: [CommonModule, RouterModule],
})
export class ContainerTypeDetailComponent implements OnInit {
  @Input() containerType: ContainerType | null = null; // Recibir el tipo de envase
  @Output() closeDetail = new EventEmitter<void>(); // Emitir evento para cerrar el detalle

  constructor() {}

  ngOnInit(): void {}

  close() {
    this.closeDetail.emit(); // Emitir evento de cerrar
  }
}
